import { setInLocalStorage } from "@/common/services/localStorageGetSet";

export const loginWithGoogle = (from: string) => {
  setInLocalStorage('redirect_to', from);

  window.location.href = `https://accounts.google.com/o/oauth2/v2/auth?state=admin&client_id=${import.meta.env.VITE_GOOGLE_OAUTH_CLIENT_ID}&redirect_uri=${window.location.origin}/oauth/google&response_type=code&scope=email&access_type=offline`;
}
